import useCreateBlogContext from 'contexts/create-blog.context';
import React from 'react';

const CreateBlogPreview = () => {
  const { createBlogForm } = useCreateBlogContext();
  const html = React.useMemo(() => {
    const raw = createBlogForm.body || '';
    try {
      // body was saved as JSON.stringify(htmlString)
      const parsed = JSON.parse(raw);
      if (typeof parsed === 'string') return parsed;
      return '';
    } catch {
      // fallback if body is already plain HTML string
      return raw;
    }
  }, [createBlogForm.body]);
  return (
    <div>
      <div>
        {createBlogForm.image ? (
          <img
            className='h-[230px] w-full mb-7 object-cover rounded'
            src={createBlogForm.image}
            alt={createBlogForm.title}
          />
        ) : null}
        <h2 className='text-2xl font-semibold mb-4 text-center'>{createBlogForm.title}</h2>
        <div className='prose max-w-none' dangerouslySetInnerHTML={{ __html: html }} />
      </div>
    </div>
  );
};

export default CreateBlogPreview;
